
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cruises/news",
      function () {
        return require("private-next-pages/cruises/news.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cruises/news"])
      });
    }
  